import { render, staticRenderFns } from "./MarketAboutTheData.vue?vue&type=template&id=29681108"
import script from "./MarketAboutTheData.vue?vue&type=script&lang=js"
export * from "./MarketAboutTheData.vue?vue&type=script&lang=js"
import style0 from "./MarketAboutTheData.vue?vue&type=style&index=0&id=29681108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports